export default {
  listItemWrapper: {
    update: (field, appData) => {
      const {
        values,
        screenValidation: { fields: fieldsArray },
        settings
      } = appData;
      const isValid =
        field.selectedData["Address|State"] === values.state ||
        // Skip check against consultation state if not requesting consult
        values.state === "";
      const fieldObject = {
        fieldName: field.name,
        isValid,
        errorMessage: !isValid
          ? settings.translations.the_pharmacy_must_be_in_the_same_state
          : null,
        title: field.title
      };
      const index = fieldsArray.findIndex(
        fieldItem => fieldItem.fieldName === field.name
      );
      if (index > -1) {
        fieldsArray[index] = fieldObject;
      } else {
        fieldsArray.push(fieldObject);
      }
    }
  }
};
